import { type GetHookResponse } from '../hooks'
import { dispositionKey } from '../keys'
import { useTantalimQuery } from '../query'
import {
  HOUR,
  MINUTE,
  type DispositionData,
  type DispositionGetInput,
  type DispositionGetSuccess,
  type DispositionId,
} from '@terros/common'

export function useDisposition(dispositionId?: DispositionId): GetHookResponse<DispositionData> {
  return useTantalimQuery<DispositionGetInput, DispositionGetSuccess, DispositionData>({
    url: '/disposition/get',
    queryKey: dispositionKey(dispositionId),
    input: { dispositionId: dispositionId ?? 'Disposition:EMPTY_DISPOSITION' },
    convertResponse: (data) => data.disposition,
    options: {
      enabled: Boolean(dispositionId),
      staleTime: 30 * MINUTE,
      gcTime: HOUR,
      retry: false,
    },
  })
}
